<template>
  <b-modal
      :visible="visible"
      id="admin-user-auth-token-modal"
      ref="modal"
      title="Redeem User Auth Token"
      @bv::modal::show="maybeLoadToken"
      hide-footer
      centered
  >
    <template v-if="loading">
      <div class="text-center">
        <b-spinner label="Spinning"></b-spinner>
      </div>
    </template>
    <template v-else>
      <p>
        <strong>User Auth Token:</strong>
      </p>
      <p>{{ authToken }}</p>
    </template>
  </b-modal>
</template>

<script>
import {API_ROUTES} from "../api";

export default {
  name: "AdminUserAuthTokenModal",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      authToken: "",
      loading: false
    }
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === 'admin-user-auth-token-modal') {
        this.maybeLoadToken();
      }
    })
  },
  methods: {
    open() {
      this.$root.$emit('bv::show::modal', 'admin-user-auth-token-modal');
    },
    close() {
      this.$root.$emit('bv::hide::modal', 'admin-user-auth-token-modal');
    },
    maybeLoadToken() {
      if (!this.authToken && !this.loading) {
        this.loading = true;
        this.$api.get(`${API_ROUTES.ADMIN_USERS}/${this.userId}/auth-token`).then(({data}) => {
          this.authToken = data.token;
          this.loading = false;
        });
      }
    }
  },
  created() {

  }
}
</script>
